import React from 'react'

import styles from "./styles/Digit.module.scss"

const Digit = ({ value, title, isFullSize = false }) => {
    const leftDigit = value >= 10 ? value.toString()[0] : '0';
    const rightDigit = value >= 10 ? value.toString()[1] : value.toString();

    return (
        <div className={`${styles['main-digit-container']} ${isFullSize ? styles.contains : ""}`}>
            <div className={styles['digit-container']}>
                <div className={`${styles['single-digit']} fw-bold`}> {leftDigit}  </div>
                <div className={`${styles['single-digit']} fw-bold`}> {rightDigit}  </div>
            </div>
            <div className={styles.title}> {title} </div>
        </div>
    )
}

export default Digit
